export default "__VITE_ASSET__C_gxb_Xp__"